// Shape of a Contact answer and the metadata its sub-inputs are rendered from.
// Shared by ContactField (rendering) and excelExport (formatting).

// Sub-inputs of a contact answer, in render order. Name is the only required
// part; phone, email and address are optional.
export const CONTACT_PARTS = [
  {
    key: 'name',
    label: 'Name',
    inputType: 'text',
    placeholder: 'Full name',
    autoComplete: 'name',
    required: true,
    fullWidth: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    inputType: 'tel',
    placeholder: 'Phone number',
    autoComplete: 'tel',
  },
  {
    key: 'email',
    label: 'Email',
    inputType: 'email',
    placeholder: 'name@example.com',
    autoComplete: 'email',
  },
  {
    key: 'address',
    label: 'Address',
    inputType: 'textarea',
    placeholder: 'Street, city, state, ZIP',
    autoComplete: 'street-address',
    fullWidth: true,
  },
];

const emptyContact = () =>
  Object.fromEntries(CONTACT_PARTS.map((part) => [part.key, '']));

// Answers are stored as { name, phone, email, address }. Tolerate the empty
// string FormFiller seeds every field with, plus plain-string answers left over
// from a field that used to be another type (kept as the name).
export const normalizeContactValue = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return Object.fromEntries(
      CONTACT_PARTS.map((part) => [
        part.key,
        typeof value[part.key] === 'string' ? value[part.key] : '',
      ]),
    );
  }
  if (typeof value === 'string' && value.trim()) {
    return { ...emptyContact(), name: value };
  }
  return emptyContact();
};

// Flatten to "Name: Jane Doe\nPhone: 555-0100" for spreadsheet cells, skipping
// the parts that were left blank.
export const formatContactValue = (value) => {
  const contact = normalizeContactValue(value);
  return CONTACT_PARTS.filter((part) => contact[part.key].trim())
    .map((part) => `${part.label}: ${contact[part.key].trim()}`)
    .join('\n');
};
